import { ReviewPeriod } from "src/app/models/review-period.model";

export abstract class ReviewTypeStrategyBase {
    abstract isReviewAllowed(rp: ReviewPeriod, isSelf: boolean): boolean;
    abstract isGoalAllowed(rp: ReviewPeriod): boolean;
}